import { FC } from 'react';
import clsx from 'clsx';
import { Box, SwiperCarousel } from '@alf/uikit';
import { useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { useHistory } from '@namespace/router';
import { useLoadCasinoFeed } from '../../../../hooks';
import { useCategories } from '../../../../store';
import { IGamesCategory } from '../../../../types';
import { IAnotherCasinoTypeListProps } from './types';

import styles from './index.module.css';

export const AnotherCasinoTypeList: FC<IAnotherCasinoTypeListProps> = ({
  feedName,
  gamesServiceUrl,
  headerComponent: HeaderComponent,
  itemComponent: ItemComponent,
  classNames = {},
  logoImg = null,
  analyticOpenCategory = null,
  analyticOpenViewAll = null,
  showArrows = false,
  slidesPerView,
  breakpoints,
  spaceBetween
}) => {
  const { carouselOverride = '', ...restClassNames } = classNames;
  const { isDesktop }: { isDesktop?: boolean } = useDeviceStore();

  const { push } = useHistory();
  const { t } = useI18n();
  useLoadCasinoFeed({ feedNames: feedName, casinoType: undefined });
  const categories: IGamesCategory[] = useCategories(feedName);
  const { casinoLive } = useGeneralRoutes();
  const { anotherCasinoTypeWidgetTextColor } = useOtherSettings();

  const onCardClick = (categoryId: string, categoryName: string) => {
    if (analyticOpenCategory) {
      analyticOpenCategory(t(categoryName));
    }
    push(`${gamesServiceUrl}/${categoryId}`);
  };

  const onViewAllClick = () => {
    if (analyticOpenViewAll) {
      analyticOpenViewAll();
    }
  };

  if (!categories.length) {
    return null;
  }

  return (
    <Box direction="column" align="center">
      <SwiperCarousel
        className={clsx(styles.carousel, carouselOverride)}
        classNames={restClassNames}
        headerComponent={
          <HeaderComponent
            viewAll={casinoLive}
            onViewAllClick={onViewAllClick}
            title={t('web.games.widget.livegames')}
            {...(logoImg ? { logo: logoImg } : {})}
          />
        }
        navigation={{ arrows: isDesktop && showArrows }}
        arrow={{
          name: 'icons/general/nav/back',
          leftClass: clsx([styles.sliderArrow, styles.sliderArrowLeft]),
          rightClass: clsx([styles.sliderArrow, styles.sliderArrowRight]),
          size: 'm',
          isHideAtEdge: true,
          moveCount: 2
        }}
        autoPlay={false}
        animationDuration={200}
        slidesPerView={slidesPerView}
        breakpoints={breakpoints}
        spaceBetween={spaceBetween}
      >
        {categories.map((category) => (
          <ItemComponent
            key={category.id}
            category={category}
            colorList={anotherCasinoTypeWidgetTextColor}
            onClick={() => onCardClick(category.id, category.title)}
          />
        ))}
      </SwiperCarousel>
    </Box>
  );
};
